export default "__VITE_ASSET__BDA1HWj1__"